import { LucideIcon, Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react'

export interface TeamMember {
  name: string
  role: string
  image: string
  bio: string
}

export interface CompanyValue {
  icon: LucideIcon
  title: string
  description: string
}

export interface Stat {
  number: string
  label: string
}

export const companyStats: Stat[] = [
  { number: '10K+', label: 'Happy Travelers' },
  { number: '50+', label: 'Destinations' },
  { number: '98%', label: 'Satisfaction Rate' },
  { number: '24/7', label: 'Support' }
]

export const aboutStats: Stat[] = [
  { number: '15+', label: 'Years Experience' },
  { number: '10K+', label: 'Happy Travelers' },
  { number: '50+', label: 'Countries Visited' },
  { number: '98%', label: 'Satisfaction Rate' }
]

export const teamMembers: TeamMember[] = [
  {
    name: 'Sarah Johnson',
    role: 'Founder & CEO',
    image: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80',
    bio: 'Passionate about creating unforgettable travel experiences for over 15 years.'
  },
  {
    name: 'Michael Chen',
    role: 'Head of Operations',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80',
    bio: 'Expert in logistics and ensuring every journey runs smoothly.'
  },
  {
    name: 'Emma Davis',
    role: 'Travel Consultant',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&q=80',
    bio: 'Specializes in crafting personalized itineraries for luxury travelers.'
  }
]

export const contactInfo = [
  {
    icon: Phone,
    title: 'Phone',
    details: ['01-5915457'],
    color: 'text-blue-600'
  },
  {
    icon: MessageCircle,
    title: 'WhatsApp',
    details: ['+977 980-1365456'],
    color: 'text-green-600'
  },
  {
    icon: Mail,
    title: 'Email',
    details: ['info@highviewtravelnepal.com'],
    color: 'text-red-600'
  },
  {
    icon: MapPin,
    title: 'Office',
    details: ['5th Floor, Crystal Complex, Sinamangal', 'Kathmandu, Nepal'],
    color: 'text-purple-600'
  }
]

export const faqs = [
  {
    question: 'How far in advance should I book my trip?',
    answer: 'We recommend booking at least 3-6 months in advance for international trips and 1-3 months for domestic travel to ensure availability and the best rates.'
  },
  {
    question: 'Do you offer travel insurance?',
    answer: 'Yes, we offer comprehensive travel insurance options to protect your investment and provide peace of mind during your journey.'
  },
  {
    question: 'Can you help with visa applications?',
    answer: 'Absolutely! Our team can guide you through visa requirements and help with the application process for most destinations.'
  },
  {
    question: 'What if I need to cancel or modify my trip?',
    answer: 'We understand that plans can change. Our cancellation and modification policies vary by package, and we\'ll work with you to find the best solution.'
  }
]
